import { Device } from '@capacitor/device';

export async function getAccessTokenDeviceCode() {
  const { uuid } = await Device.getId();
  const info = await Device.getInfo();
  return (info.name ?? info.model) + '#' + info.operatingSystem + '#' + uuid;
}